import { useState, useEffect } from "react";
import { useLocation, Link } from "react-router-dom";
import { getMypageCourseList } from "../../../../services/apiCourseApplicant";
import CourseApplicantSearchForm from "./CourseApplicantSearchForm";
import CourseDataTable from "./CourseDataTable";
import { getCodeMasterList } from "../../../../services/apiCodeMaster";
import Loading from "../../../../components/ui/Loading";
import Progress from "../../../../components/ui/Progress";

// 申込済みの講座
const AppliedCourseList = () => {
  // 検索条件
  const [searchCondition, setSearchCondition] = useState({});
  // 申込講座一覧データ
  const [tableData, setTableData] = useState([]);
  // 表示ページ
  const [currentPage, setCurrentPage] = useState(1);
  // ローディング表示
  const [loading, setLoading] = useState(false);
  // 当選状況チェックボックス
  const [elements, setElements] = useState([]);
  // 申込済み講座
  const AppliedCourse = 1;
  const pathname = useLocation().pathname;

  // 検索フォーム
  const returnSearchForm = () => {
    return (
      <CourseApplicantSearchForm
        displayType={AppliedCourse}
        elements={elements}
        setSearchCondition={setSearchCondition}
      />
    );
  };

  // タブ
  const returnTab = () => {
    return (
      <div className="p-course-tab" role="menubar">
        <button
          type="button"
          className="p-course-tab__link active"
          role="menuitem"
          aria-current="page"
        >
          申込済みの講座
        </button>
        <Link
          to="/mypage/course/attended"
          className="p-course-tab__link"
          role="menuitem"
        >
          これまで受講した講座
        </Link>
      </div>
    );
  };

  // 申込済みの講座一覧
  const returnDataTable = () => {
    return (
      <CourseDataTable
        displayType={AppliedCourse}
        tableData={tableData}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
      />
    );
  };

  const getDispCourseList = async () => {
    // 一覧データ
    let setData = [];
    const url = pathname.split("/").slice(-1)[0];
    const data = await getMypageCourseList(searchCondition, url);
    if (data == undefined || !data) return;
    setCurrentPage(1);
    // 検索終了したらローディング表示終了
    setLoading(false);

    if (data.data_list.length > 0) {
      // 一覧データ作成
      const addData = data.data_list.map((d, index) => {
        return {
          course_id: d.course_id,
          course_name: d.course_name,
          organ: d.organ,
          period_f: d.period_f,
          period_t: d.period_t,
          period: d.period,
          in_period: d.in_period,
          lottery_status: d.lottery_status,
          is_cancelable: d.is_cancelable,
        };
      });
      // 一覧データセット
      setData = setData.concat(addData);
      setTableData(setData);
    }
  };

  // 初回レンダリング
  useEffect(() => {
    // 一覧データ初期化
    setTableData([]);
    // ローディング表示開始
    setLoading(true);

    // 抽選ステータス取得
    (async function () {
      const ls_data = await getCodeMasterList({ code: "CD003" }, true);
      if (ls_data == undefined || !ls_data) return;
      setElements(
        ls_data.map((d) => {
          return {
            label: d.d_text,
            value: d.d_value,
          };
        })
      );
    })();

    // 講座申込情報取得
    (async function () {
      // 講座一覧
      await getDispCourseList();
    })();
  }, [searchCondition]);

  return (
    <div className="l-page-right">
      <div className="l-page-con">
        <h1 className="p-heading01">申込状況・受講履歴</h1>
        {returnTab()}
        {returnSearchForm()}
        <div className="p-course-con">
          <div className="p-course-result01 p-course-panel active">
            {returnDataTable()}
          </div>
        </div>
      </div>
      {loading ? <Loading /> : <></>}
      {loading ? <Progress /> : <></>}
    </div>
  );
};

export default AppliedCourseList;
